module.exports = "Ext.ns(\"SF.role\"),SF.role.isCalendarDelegate=function(a){return\"CalendarAdministrator\"===a||\"CalendarManager\"===a};"